import { from } from 'rxjs';
import Vue from 'vue';
import App from './App.vue';
import VueRouter, { RouteConfig } from 'vue-router';
import VideoPage from './videoPage.vue';
import RouterTab from '@/components/RouterTab.vue';
import BonusPool from '@/components/pc/BonusPool_.vue';
import KV2 from './KV2.vue';
import Rank from '@/components/pc/Rank.vue';
import MaskKV from './maskKV.vue';
import PerSwiper from '@/components/pc/PerSwiper.vue';
import Mask from './mask.vue'


import PortalVue from 'portal-vue';
Vue.use(PortalVue);

Vue.config.productionTip = false;

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/video',
    component: VideoPage,
  },
  {
    path: '/video',
    component: VideoPage,
  },
  {
    path: '/live',
    component: () => import('./livePage.vue'),
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});
Vue.use(VueRouter);

// new Vue({
//   router,
//   render: h => h(App),
// }).$mount('#app')

const newNode = document.createElement('div');
newNode.id = 'open-kv';
document.body.append(newNode);
console.log('localstorage', localStorage)
const maskNode = document.createElement('div');
maskNode.id = 'open-mask';
document.body.append(maskNode);

const bgvideoParent = document.getElementById('bgvideo')?.parentNode as HTMLElement;
if (bgvideoParent) {
  console.log('bgvideoParent', bgvideoParent)
  // bgvideoParent.className = 'bg-parent'
  bgvideoParent.id = 'bg-parent'
  // bgvideoParent.appendChild(maskNode)
}


new Vue({
  render: h => h(Mask),
}).$mount('#MXRUVe87Vlz')
// new Vue({
//   render: h => h(MaskKV),
// }).$mount('#open-mask')

new Vue({
  render: h => h(KV2),
}).$mount('#open-kv')


new Vue({
  render: h => h(Rank),
}).$mount('#Mz96JnkJjqV')
new Vue({
  render: h => h(RouterTab),
}).$mount('#M4UT0Agl6tu')
new Vue({
  render: h => h(BonusPool),
}).$mount('#MPrvEUItgOA');
new Vue({
  render: h => h(PerSwiper),
}).$mount('#MnVU25ztrvo');
const webshare = document.getElementById('webShare') as HTMLElement
webshare.style.display = 'none'

// const webPlay = document.getElementsByClassName('bpx-player-ctrl-setting-box') as any
// webPlay.style.right = 0;